module.exports = __webpack_public_path__ + "assets/scrollmagic.df6445b4.svg";